import { OrderedMap, Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { CourseMapper } from "features/planner/planner.mappers";

const initialState = Map({
  visible: "",
});

export default (state = initialState, action) => {
  const { type, payload, error } = action;

  switch (type) {
    case ACTIONS.GET_EMPLOYEE_COURSES: {
      if (error) return state;
      return state.set(
        action.cardId.toString(),
        OrderedMap(
          payload.map(employeeCourse => [
            employeeCourse.courseId.toString(),
            CourseMapper.from(employeeCourse),
          ]),
        ),
      );
    }

    case ACTIONS.CLEAR_EMPLOYEE_COURSES: {
      return state.delete(action.cardId.toString());
    }

    case ACTIONS.DISPLAY_EMPLOYEE_CARD_COURSE_GAPS: {
      return state.set("visible", action.cardId.toString());
    }

    default: {
      return state;
    }
  }
};
